import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { getPlayersMoto } from '../../api/getPlayersMoto';
import * as func from '../../utils/funcs';

import BasicButtons from '../../partials/BasicButtons';
import HeaderTopic from '../../partials/HeaderTopic';

import styles from './ProfileEdit.module.css';
import iconProfile from './../../graphics/elements/profile_photo.svg';
import { editPlayer } from '../../api/editPlayer';

/* import playerGenericPic from "./../../graphics/elements/profile_photo.svg"; */

function ProfileEdit(props) {
  const { user, refreshStates } = props;
  const history = useHistory();
  const { leagueId } = useParams();

  const [motos, setMotos] = React.useState([]);
  /* const [cities, setCities] = React.useState([]); */
  const player = func.userToPlayer(user);

  /* const [fName, setFName] = React.useState("");
  const [lName, setLName] = React.useState(""); */
  /* const [city, setCity] = React.useState(""); */

  const [sentence, setSentence] = React.useState(player.sentence);
  const [grade, setGrade] = React.useState(player.grade);
  const [school, setSchool] = React.useState(player.school);
  /* const [shirtSize, setShirtSize] = React.useState(""); */
  const [profilePic, setProfilePic] = React.useState(null);
  const [viewProfilePic, setViewProfilePic] = React.useState(
    player.profile_pic !== null ? player.profile_pic : iconProfile
  );

  React.useEffect(() => {
    let mounted = true;
    getPlayersMoto().then((data) => {
      if (data.error) {
        // TODO: add connection Error
      } else if (mounted) {
        setMotos(data);
      }
    });
    return function cleanup() {
      mounted = false;
    };
  }, []);

  /* React.useEffect(() => {
    let mounted = true;
    api.getCities().then((data) => {
      if (data.error) {
        // TODO: add connection Error
      } else if (mounted) {
        setCities(data);
      }
    });
    return function cleanup() {
      mounted = false;
    };
  }, []); */

  const handleClickEdit = async () => {
    await editPlayer(player.user.id, profilePic, grade, school, sentence);
    /* const updatedGroupPlayers = await api.getGroupPlayers(leagueId, teamId);
    setPlayers(updatedGroupPlayers); */
    history.push(`/leagues/${leagueId}/profile`);

    // After @Nisser will add another endpoint for editing Users
    //api.editUser(playerId, fName, lName);
  };

  return (
    <div className={styles.editPlayer}>
      <HeaderTopic topic="עריכת פרטי שחקן" />
      <BasicButtons user={user} refreshStates={refreshStates} />

      <form>
        {/* <input
          type="text"
          placeholder="שם פרטי"
          value={fName}
          onChange={(e) => setFName(e.target.value)}
        />

        <input
          type="text"
          placeholder="שם משפחה"
          value={lName}
          onChange={(e) => setLName(e.target.value)}
        /> */}

        <img src={viewProfilePic} alt="תמונת השחקן" />

        <input
          className="hideMe"
          id="editProfilePic"
          type="file"
          accept="image/png, image/jpeg"
          onChange={(e) => {
            setProfilePic(e.target.files[0]);
            setViewProfilePic(URL.createObjectURL(e.target.files[0]));
          }}
        />

        <div
          className="btnMedium"
          onClick={() => document.querySelector("#editProfilePic").click()}
        >
          עדכון תמונה
        </div>

        {/* <select
          name="city"
          value={city}
          onChange={(e) => setCity(e.target.value)}
        >
          <option value="" hidden>
            עיר
          </option>
          {cities.map((city) => {
            return (
              <option key={city.id} value={city.id}>
                {city.name}
              </option>
            );
          })}
        </select> */}

        <select
          name="grade"
          value={grade}
          onChange={(e) => setGrade(e.target.value)}
        >
          <option value="" hidden>
            כיתה
          </option>
          <option value={4}>ד'</option>
          <option value={5}>ה'</option>
          <option value={6}>ו'</option>
          <option value={7}>ז'</option>
          <option value={8}>ח'</option>
          <option value={9}>ט'</option>
          <option value={10}>י'</option>
          <option value={11}>יא'</option>
          <option value={12}>יב'</option>
          <option value={13}>בוגרים</option>
        </select>

        <input
          type="text"
          value={school}
          onChange={(e) => setSchool(e.target.value)}
          placeholder="בית ספר"
        />

        <select
          name="moto"
          value={sentence}
          onChange={(e) => setSentence(e.target.value)}
        >
          <option value="" hidden>
            מוטו לחיים
          </option>
          {motos.map((moto) => (
            <option key={moto.id} value={moto.text}>
              {moto.text}
            </option>
          ))}
        </select>



        <span></span>

        <input
          type="button"
          className="btnLarge"
          value="עריכת שחקן"
          onClick={handleClickEdit}
        />
      </form>
    </div>
  );
}

export default ProfileEdit;
